var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-radiogroup.ts
import "@adornis/chemistry/elements/components/x-flex.js";
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { FormField } from "@adornis/formfield/form-field.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { fromEvent, takeUntil } from "rxjs";
var XRadioGroup = class extends FormField {
  firstUpdated() {
    this.initAllRadioButtons();
    fromEvent(this, "button-activated").pipe(takeUntil(this.disconnected)).subscribe((e) => this.handleEvent(e));
    this.value.observable.pipe(takeUntil(this.disconnected)).subscribe((val) => {
      this.initAllRadioButtons();
      if (!this._radioButtons?.length)
        return;
      for (const button of this._radioButtons) {
        if (button.selectable === val)
          button.value.next(true);
        else
          button.value.next(false);
      }
    });
  }
  render() {
    return html` <slot> </slot> `;
  }
  handleEvent(e) {
    const activatedButton = e.target;
    this._radioButtons?.filter((btn) => btn !== activatedButton).forEach((rbtn) => rbtn.value.next(false));
    this.value.next(activatedButton.selectable);
    this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
  }
  initAllRadioButtons() {
    this._radioButtons = Array.from(
      this.querySelectorAll(`${this.nodeName.split("-")[0]?.toLowerCase() ?? DesignSystem.prefix}-radiobutton`)
    );
  }
};
XRadioGroup = __decorateClass([
  customElement("x-radiogroup")
], XRadioGroup);
var XRadioButton = class extends FormField {
  constructor() {
    super(...arguments);
    this.label = "";
    this.reverse = false;
  }
  styles() {
    return [
      {
        ":host": { cursor: "pointer", userSelect: "none", "-webkit-tap-highlight-color": "transparent" },
        ":host([disabled])": { pointerEvents: "none", filter: "grayscale(1)", opacity: ".5" },
        "#knob": {
          width: "22px",
          height: "22px",
          borderRadius: "50%",
          border: `2px solid ${this.colors.accent}`,
          padding: "2px",
          transition: "backgroundColor .12s, color .12s",
          background: this.disabled ? this.colors.accent : this.colors.neutral.shade(100),
          color: this.value.value ? this.colors.on.accent : "unset"
        },
        "#knob-content": {
          background: this.colors.accent,
          height: "100%",
          width: "100%",
          borderRadius: "50%"
        }
      }
    ];
  }
  render() {
    return xComponents(html`
      <x-flex
        tabindex="0"
        horizontal
        space="sm"
        crossaxis-center
        ?reverse=${this.reverse}
        @keyup=${(e) => {
      if (e.key === "Enter")
        this.activate();
    }}
        @click=${() => this.activate()}
      >
        <x-flex id="knob" horizontal center flex-none crossaxis-center>
          ${this.value.value ? html` <x-flex id="knob-content"> </x-flex> ` : nothing}
        </x-flex>
        ${this.label ? html` <x-text> ${this.label} </x-text> ` : nothing}
        <x-text> <slot></slot> </x-text>
        ${this.error ? html` <x-text tone="error"> (${this.error}) </x-text> ` : nothing}
      </x-flex>
    `);
  }
  activate() {
    this.dispatchEvent(new CustomEvent("button-activated", { bubbles: true }));
  }
};
__decorateClass([
  property()
], XRadioButton.prototype, "label", 2);
__decorateClass([
  property({ type: Boolean })
], XRadioButton.prototype, "reverse", 2);
__decorateClass([
  property()
], XRadioButton.prototype, "selectable", 2);
XRadioButton = __decorateClass([
  customElement("x-radiobutton")
], XRadioButton);
export {
  XRadioButton,
  XRadioGroup
};
